export const LISTE_EMPLACEMENT_PRESSE = {
  title: 'Liste des emplacements presse',
  breadcrumb: {
    racine: 'Accueil',
    parametrage: 'Paramétrage',
    liste: 'Liste des emplacements presse',
  },
  actions: {
    add: 'Ajouter un emplacement presse',
    search: 'Rechercher',
    edit: 'Modifier',
    delete: 'Supprimer',
    archiver: 'Archiver',
  },
  tab: {
    libelle: 'Libellé',
    code: 'Code',
  },
};

export const ADD_EMPLACEMENT_PRESSE = {
  titleAdd: 'Ajouter un emplacement presse',
  titleEdit: 'Modifier un emplacement presse',
  informationEmplacementPresse: {
    libelle: 'Libellé',
    code: 'Code',
  },
  success: {
    add: 'L\'emplacement a été ajouté avec succès.',
    edit: 'L\'emplacement a été modifié avec succès.',
  },
};
